import React, { useContext, useEffect, useState } from 'react'
import { 
    Container,
    FieldDiv,
    FieldText
 } from './style'
import { movementHeaders } from '../../../../../pages/ClientPanel/Stock/MovementsTable/utils'
import SectionContext from '../../../../../contexts/SectionContext'
import { completeHeaders } from '../../../../../pages/ClientPanel/Stock/StockTable/utils'

interface DropdownMenu {
    ref: HTMLDivElement,
    text: string,
    onClick: (value: string) => void
}

const FieldsDropdown = React.forwardRef<HTMLDivElement, DropdownMenu>((props, forwardRef) => {
    const { stockSection } = useContext(SectionContext)
    let filteredHeaders = []
    if (stockSection == 'stock'){
        filteredHeaders = completeHeaders
    } else {
        filteredHeaders = movementHeaders
    }
    if (props.text !== ""){
        filteredHeaders = filteredHeaders.filter(str => str.toLowerCase().includes(props.text.toLowerCase()))
    }

    return (
        <Container ref={forwardRef}>
            {filteredHeaders.map(field => 
                <FieldDiv key={field} onClick={() => props.onClick(field)}>
                    <FieldText>{field}</FieldText>
                </FieldDiv>              
            )}
        </Container>
    )
})

FieldsDropdown.displayName = "FieldsDropdown";

export default FieldsDropdown